export const getTypeOf = <T>(value: string): T => {
  return JSON.parse(value) as T;
};
